import { Card, Text } from '@mantine/core';
import classnames from 'classnames';
import styles from './ModelCard.module.css';
import { Image, Wrapper } from './ModelCard.style';

export type IModel = {
  imageUrl: string;
  title: string;
  description: string;
  uploaderName: string;
  uploaderAvatar: string;
  daysAgo: number;
  daysAgoText: string;
  likes: number;
  views: number;
  aiPrompt: string;
};

export type ModelCardProps = {
  model: IModel;
  baseImageUrl: string;
  onClick?: () => void;
  personal?: boolean;
  containImage?: boolean;
  small?: boolean;
  noClick?: boolean;
};

export function ModelCard(props: ModelCardProps) {
  const { model, baseImageUrl, personal, containImage = true, noClick, small } = props;

  const {
    imageUrl,
    title,
    uploaderName,
    uploaderAvatar,
    daysAgo,
    likes,
    views,
    aiPrompt,
    daysAgoText,
  } = model;

  function renderDetails() {
    if (personal) {
      if (daysAgoText) {
        return <>{daysAgoText}</>;
      } else if (daysAgo) {
        return <> {daysAgo} days ago</>;
      }
    } else {
      return (
        <>
          <Text size='xs' fw={600} c='#778'>
            Prompt: {aiPrompt}
          </Text>
          <div className={styles.stats}>
            <Text size='sm' fw={500}>
              ❤️ {likes}
            </Text>
            <Text size='sm' fw={500}>
              👀 {views}
            </Text>
          </div>
        </>
      );
    }
  }
  function renderUploader() {
    if (!uploaderName) return null;

    return (
      <Uploader uploaderAvatar={uploaderAvatar} uploaderName={uploaderName} daysAgo={daysAgo} />
    );
  }

  const style = {
    backgroundImage: `url(${baseImageUrl + imageUrl})`,
  };

  const className = classnames('ModelCard-wrapper', {
    small,
    noClick,
  });

  const classNameImage = classnames(styles.imageContainer, {
    containImage,
    small,
  });

  const altTitle = small ? title : '';

  return (
    <Wrapper className={className} data-testid='ModelCard-wrapper'>
      <Card
        shadow='md'
        radius='lg'
        className={styles.card}
        onClick={props.onClick}
        title={altTitle}
      >
        <Image style={style} className={classNameImage} />
        {renderUploader()}
        {!small && (
          <Text lineClamp={1} size='md' fw={600} ff='heading' style={{ textAlign: 'center' }}>
            {title}
          </Text>
        )}
      </Card>
    </Wrapper>
  );
}

export default ModelCard;
